export default {
  selectedTab: '1',
  versionProps: {
    title: '边框',
    widgetNum: '3',// 每种组件的唯一编码
    version: '1',  // 每种组件的版本号
    upgrade: true,
    docUrl: '/datavisual/doc/widget'
  },
  viewProps: {
    width: '300',
    height: '300',
    top: 0,
    left: 0,
  },
}
